import { render, staticRenderFns } from "./os.vue?vue&type=template&id=c7bdf800"
import script from "./os.vue?vue&type=script&lang=js"
export * from "./os.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7bdf800')) {
      api.createRecord('c7bdf800', component.options)
    } else {
      api.reload('c7bdf800', component.options)
    }
    module.hot.accept("./os.vue?vue&type=template&id=c7bdf800", function () {
      api.rerender('c7bdf800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/os.vue"
export default component.exports